export default __webpack_public_path__ + "static/media/03d.a7e80164.jpg";